import React from 'react';
import { SubNavigationPage } from 'types/IPage';
import LinkButton from '@flow/components/ui/button/LinkButton';
import { SubNavigationWrapper } from '@flow/components/ui';

interface Props {
  navigation: any;
}

interface State {

}

const SLUGS_WITH_STICKY_NAVI_DISABLED = ['history', 'historia'];

class PageSubnavigation extends React.Component<Props, State> {
  render() {
    const {
      navigation
    } = this.props;

    if (!navigation) return null;

    const {
      link,
      title,
      sub_pages,
    } = navigation;

    // This is just a quick and dirty fix to handle client wishes to disable sticky navigation on certain pages
    const isStickyDisabled = (): boolean => {
      const { slug } = navigation;
      return SLUGS_WITH_STICKY_NAVI_DISABLED.includes(slug);
    }

    return (
      <SubNavigationWrapper className={isStickyDisabled() ? 'sticky-disabled': ''}>
        <li>
          <LinkButton href={link} label={title} exact={true} buttonClassName={'smaller-text'}/>
        </li>
        {sub_pages.map((page: SubNavigationPage, index: number) =>
          <li key={index}>
            <LinkButton href={page.link} label={page.title} buttonClassName={'smaller-text'}/>
          </li>
        )}
      </SubNavigationWrapper>
    )
  }
}

export default PageSubnavigation;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/default/ui/PageSubnavigation.tsx